export default class EmbedToken{
    constructor(obj) {
      obj = obj || {};
      this.accessToken = obj.accessToken,
      this.expiry = obj.expiry
      this.reportId = obj.reportId;
      this.embedUrl = obj.embedUrl;
    }
  
    modeloValido() {
      return !!(this.accessToken && this.expiry);
    }
  }